export const FETCH_PATH = process.env.REACT_APP_FETCH_PATH;
export const VERSION = process.env.REACT_APP_VERSION;
export const COMMIT_HASH = process.env.REACT_APP_COMMIT_HASH;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const NODE_ENV = process.env.NODE_ENV;